<template>
  <div class="allVideo">
    <!-- 标题 -->
    <p class="module_title">
      <span>全部</span
      ><span class="close" @click="closeVideos"
        ><img src="./../../../assets/images/activity/harvard/close.png" alt=""
      /></span>
    </p>
    <!-- 所有视频列表 -->
    <van-tabs
      class="videos_list"
      v-model="curTopicId"
      animated
      sticky
      :offset-top="offsetTop"
      :swipe-threshold="4.5"
      title-inactive-color="#333333"
      title-active-color="#333333"
      line-height="3px"
      line-width="36px"
      :duration="0"
      color="#D4A437"
      @click="switchPage"
    >
      <van-tab
        :title="item.topicTitle"
        v-for="item in topicList"
        :key="item.id"
        style="padding-bottom: 60px"
      >
        <!-- 专题名称 -->
        <div class="special_title">{{ item.topicName }}</div>
        <!-- 视频列表 -->
        <div
          v-for="(video, index) in videosList"
          :key="video.fnVideoId"
          class="special_list"
          :class="curVideoId == video.fnVideoId ? 'special_cur' : ''"
          @click="toPlayVideo(video.fnVideoId, video, index, item.topicTitle)"
        >
          <div class="special_img" v-lazy:background-image="video.videoImg">
            <span class="mark">播放中···</span>
          </div>
          <div class="right_content">
            <p class="title">{{ video.videoTitle }}</p>
            <p class="expert">
              <span class="name">{{ harvardData[video.expertId].name }}</span
              >{{ harvardData[video.expertId].level }}
            </p>
            <p class="comment">
              <span class="video_num">{{ fomatterNum(video.views) }}播放</span
              ><span class="collect_num"
                >{{ fomatterNum(video.likes) }}点赞</span
              >
            </p>
          </div>
        </div>
        <empty-list
          :emptyText="'该系列课程暂未开课，请耐心等待哦～'"
          v-show="emptyListShow"
        ></empty-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<style lang="less">
@import './../../../assets/less/harvard.less';
.allVideo {
  display: none;
  position: relative;
  bottom: 0;
  left: 0;
  right: 0%;
  z-index: 9;
  background: #ffffff;
  overflow-y: auto;
  .van-list__loading {
    background: @color255;
  }
  .module_title {
    color: @color51;
    font-weight: bold;
    font-size: @fontSize16;
    overflow: hidden;
    margin-left: 12px;
    span {
      width: 50%;
      padding: 15px 0 20px;
      display: block;
      float: left;
    }
    span.close {
      height: 58px;
      display: inline-block;
      float: right;
      text-align: right;
      padding: 0;
      img {
        width: 15px;
        height: 15px;
        margin-top: 15px;
        margin-right: 12px;
      }
    }
  }
  .videos_list {
    width: 100%;
    .van-sticky {
      // border-bottom:1px solid rgba(242,242,242,1);
      .van-tab--active {
        font-size: @fontSize16;
      }
    }
    .special_title {
      margin: 16px 12px 0;
      background-color: rgba(255, 248, 240, 1);
      background-image: url(./../../../assets/images/activity/harvard/bg3.png);
      background-size: auto 100%;
      background-position: right top;
      background-repeat: no-repeat;
      padding: 11px 11px 10px;
      font-size: @fontSize16;
      color: @colorY3;
      font-weight: bold;
    }
    .special_list {
      margin: 0 12px;
      padding: 15px 0;
      overflow: hidden;
      border-bottom: 1px solid rgba(242, 242, 242, 1);
      .special_img {
        width: 140px;
        height: 80px;
        margin-right: 9px;
        float: left;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        border-radius: 4px;
        background-color: #f2f2f2;
        position: relative;
        span.mark {
          display: none;
        }
      }
      .right_content {
        p.title {
          font-size: @fontSize15;
          color: @color51;
          font-weight: bold;
          margin: 5px 0 11px;
          line-height: 1.2;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        p.expert {
          font-size: @fontSize12;
          line-height: 1.2;
          color: @color153;
          margin-bottom: 22px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          span.name {
            color: @color51;
            margin-right: 5px;
          }
        }
        p.comment {
          font-size: @fontSize12;
          color: @color153;
          line-height: 1;
          span.video_num {
            margin-right: 8px;
          }
        }
      }
    }
    .special_cur {
      .special_img {
        span.mark {
          display: block;
          background-color: @colorH;
          padding: 3px 9px;
          border-radius: 0px 4px 0px 4px;
          color: @color255;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
      .right_content {
        p.title {
          color: @colorH;
        }
      }
    }
  }
}
</style>

<script>
import API from './../../../utils/axiosApi/harvardApi'
import emptyList from '@//components/contents/emptyList.vue'
import { fomatterNum } from '@/assets/js/common.js'
export default {
  name: 'allVideos',
  data() {
    return {
      curTopicId: null,
      removeTopicId: null,
      emptyListShow: false,
      topicList: null,
      videosList: null,
      curVideoId: null,
      offsetTop: 0,
      screenHeight: 0,
    }
  },
  props: ['harvardData'],
  components: {
    emptyList,
  },
  watch: {
    screenHeight(val) {
      this.screenHeight = val
      $('.allVideo').css('height', val - this.offsetTop + 'px')
    },
  },
  mounted() {
    let that = this
    window.onresize = () => {
      return (() => {
        that.screenHeight = document.body.clientHeight
      })()
    }
  },
  methods: {
    openAllVideo: async function (obj) {
      if (this.topicList == null || this.topicList.length == 0) {
        await this.getAllTopic()
      } else {
        this.topicList = this.topicList
      }
      this.offsetTop = $('#HFVideo')[0].clientHeight
      $('.allVideo').css(
        'height',
        $(document.body).height() - this.offsetTop + 'px'
      )

      $(window).resize(function () {
        this.offsetTop = $('#HFVideo')[0].clientHeight
        $('.allVideo').css(
          'height',
          $(document.body).height() - this.offsetTop + 'px'
        )
      })

      this.topicList.forEach((item, index) => {
        if (item.topicId == obj.topicId) {
          this.curTopicId = index
          this.removeTopicId = index
        }
      })
      this.getVideos(obj.topicId)
      this.curVideoId = obj.curPlayVideoId
      $('.allVideo').slideDown()
    },
    fomatterNum,
    // 关闭查看全部视频
    closeVideos: function () {
      this.$emit('closeVideo')
      $('.allVideo').slideUp()
    },
    // 获取所有专题
    getAllTopic: function () {
      return new Promise((resolve, reject) => {
        if (this.topicList == null || this.topicList.length == 0) {
          API.getAllTopic({}, (res) => {
            if (res.code == '200') {
              this.topicList = res.data
              resolve(res.data)
            }
          })
        }
      })
    },
    // 根据专题获取视频
    getVideos: function (curTopicId) {
      API.getVideosByTopic({ topic_id: curTopicId }, (res) => {
        if (res.code == '200') {
          if (
            !res.data ||
            !res.data.harvardVideos ||
            res.data.harvardVideos.length == 0
          ) {
            this.emptyListShow = true
          } else {
            this.videosList = res.data.harvardVideos
            this.emptyListShow = false
          }
        } else {
          this.emptyListShow = true
        }
      })
    },
    // 切换专题
    switchPage: function (name, title) {
      if (this.removeTopicId == name) return false
      sensors.track('ExchangeTopic', {
        content_title: title,
        page_name: this.$route.meta.title,
      })
      gio('track', 'hafovideopage_allvideopop_switchtopic')
      if ($('.van-sticky').css('position') == 'fixed') {
        $('.van-tabs__content').css(
          'min-height',
          $(document.body).height() -
            this.offsetTop -
            $('.van-sticky').outerHeight() +
            'px'
        )
      }
      this.removeTopicId = this.curTopicId
      this.videosList = []
      this.getVideos(this.topicList[name].topicId)
    },
    // 播放视频

    toPlayVideo: function (videoId, item, index, topicTitle) {
      const time =
        item.videoDuration.split(':')[0] * 60 +
        item.videoDuration.split(':')[1] * 1 -
        1
      sensors.track('VideoClick', {
        content_id: videoId,
        content_title: item.videoTitle,
        author: '',
        length_of_time: time,
        content_topic: topicTitle,
        is_tab: false,
        page_name: this.$route.meta.title,
        position: index + 1,
      })
      this.$emit('playCurVideo', videoId)
      this.curVideoId = videoId
    },
  },
}
</script>
